import React, { useState, useEffect } from "react";
import api from "../../services/api";
import Button from "@material-ui/core/Button";

// 📦 Pega a versão atual do package.json
const packageVersion = require("../../../package.json").version;

// 🔧 Verifica se controle de versão está ativado no .env
const versionControlEnabled = process.env.REACT_APP_VERSION_CONTROL === "true";

const VersionControl = () => {
  const [storedVersion] = useState(window.localStorage.getItem("version") || "0.0.0");

  const handleUpdateVersion = async () => {
    // Atualiza o localStorage com a nova versão
    window.localStorage.setItem("version", packageVersion);

    // Envia a nova versão para o backend (opcional)
    try {
      await api.post("/version", { version: packageVersion });
    } catch (error) {
      console.error("Erro ao atualizar versão no backend:", error);
    }

    // Limpa o cache do navegador (Service Workers e outros)
    caches.keys().then(function (names) {
      for (let name of names) caches.delete(name);
    });

    // Aguarda 1s para garantir limpeza e recarrega a página
    setTimeout(() => {
      window.location.reload(true);
    }, 1000);
  };

  return (
    <div>
      {versionControlEnabled && storedVersion !== packageVersion && (
        <Button
          variant="contained"
          size="small"
          style={{
            backgroundColor: "red",
            color: "white",
            fontWeight: "bold",
            right: "15px",
          }}
          onClick={handleUpdateVersion}
        >
          Nova versão disponível! Clique aqui para atualizar
        </Button>
      )}
    </div>
  );
};

export default VersionControl;
